import { useEffect } from 'react';
import ThemeProvider from './theme';
import Router from './routes';
import NotistackProvider from './components/NotistackProvider';
import { ProgressBarStyle } from './components/ProgressBar';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import { LoadingPortal } from './components/LoadingScreen';
import { ChartStyle } from './components/chart';
import TourGuideProvider from './components/TourGuideProvider';
import useGraphQuery from './hooks/useGraphQuery';
import { QUERY_APP_SETTINGS } from './graphql/appSetting';
import useRedux from './hooks/useRedux';

// ----------------------------------------------------------------------

export default function App() {
  const { data } = useGraphQuery(QUERY_APP_SETTINGS);
  const setting = data?.appSettings?.all;
  const { setAppSetting } = useRedux();

  useEffect(() => {
    if(setting){
      setAppSetting(setting);
    }
  },[setting])

  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <NotistackProvider>
          <ProgressBarStyle />
          <ChartStyle />

          <TourGuideProvider>
            <Router />
          </TourGuideProvider>

          <LoadingPortal />
        </NotistackProvider>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}
